import React, { useState } from 'react';

import { Portal } from '@api/v4/private/PortalTypes';
import PortalSettings from './portal_settings';
import SearchBar from './search_bar';

interface HeaderBackgroundProps {
  admin: boolean;
  headerHexColor: string;
  headerNameOverlay: boolean;
  portal: Portal;
  editMode: boolean;
  toggleEditMode: () => void;
}

const HeaderBackground: React.FunctionComponent<HeaderBackgroundProps> = ({
  admin,
  editMode,
  headerHexColor,
  headerNameOverlay,
  portal,
  toggleEditMode,
}) => {
  const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const toggleForm = (): void => setShowForm((prevState) => !prevState);

  return (
    <header className="portal-header">
      <div
        className="portal-header__image"
        style={{ backgroundImage: portal.headerUrl ? `url(${portal.headerUrl})` : "" }}
      >
        {headerNameOverlay
          && (
            <div className="portal-header__text">
              <h1 className="portal-header__text--title" style={{ color: `#${headerHexColor}` }}>{t("Welcome to")}</h1>
              <h1 className="portal-header__text--title" style={{ color: `#${headerHexColor}` }}>
                <span className="portal-header__text--title-bold">{portal.name}</span>
              </h1>
            </div>
          )
        }
        {admin
          && (
            <PortalSettings
              editMode={editMode}
              showSettingsDropdown={showSettingsDropdown}
              setShowSettingsDropdown={setShowSettingsDropdown}
              showForm={showForm}
              toggleEditMode={toggleEditMode}
              toggleForm={toggleForm}
            />
          )
        }
        <SearchBar
          searchUrl={portal.searchUrl}
        />
      </div>
    </header>
  );
};

export default HeaderBackground;
